import axios from "axios"
import { CONST_API_CLIENT_PTF_PERIODE_BC_BL_POST_GET_BL_MANQUANTS_OF_GIVEN_MONTH_ENDPOINT } from "../../../../../endpoints"
import { IBonsLivraisonManquantsOfGivenMonthRequestModel, IBonsLivraisonManquantsOfGivenMonthResponseModel } from "./_models"

export function getBonsLivraisonManquantsOfGivenMonthRequest(payload: IBonsLivraisonManquantsOfGivenMonthRequestModel) {
     return axios.post<IBonsLivraisonManquantsOfGivenMonthResponseModel>(CONST_API_CLIENT_PTF_PERIODE_BC_BL_POST_GET_BL_MANQUANTS_OF_GIVEN_MONTH_ENDPOINT, payload)
}
